<template lang="html">
  <section class="news">
    <div class="row">
      <div id='loadingmessage' style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;" v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 40%;">
          <img src='../../assets/snakes.gif' /></p>
        </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Edit User</h4>
            <form class="form-sample" @submit="onSubmit">
              <p class="card-description">
                <strong>Basic info</strong>
              </p>
              <p style="color:red;">{{error}}</p>
              <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Username">
                    <b-form-input type="text" v-model="username" required=""></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group horizontal label="Name">
                    <b-form-input type="text" v-model="name" required=""></b-form-input>
                  </b-form-group>
                  </div>
                  </div>
                       <div class="row">
                          <div class="col-md-6">
                  <b-form-group horizontal label="Email">
                    <b-form-input type="text" v-model="email" required=""></b-form-input>
                  </b-form-group>
                </div>
                    <div class="col-md-6">
                       <b-form-group horizontal label="Phone No">
                   <b-form-input type="text" v-model="phone" required=""></b-form-input>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Organization">
                    <b-form-input type="text" v-model="organization" required=""></b-form-input>
                  </b-form-group>
                  </div>
                   <div class="col-md-6">
                       <b-form-group horizontal label="Is Rescuer">
                  <b-form-select v-model="is_rescuer" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                   </b-form-group>
                  </div>
                    <div class="col-md-6">
                    <b-form-group horizontal label="Is SnakeExpert">
                  <b-form-select v-model="issnakeexpert" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                  </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group horizontal label="Is Rescuer Available?">
                  <b-form-select v-model="is_rescuer_Available" class="mb-3">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                    </b-form-select>
                  </b-form-group>
                  </div>
                  </div>
                <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Update User Details</b-button>
            </form>
          </div>
          <hr>
          <div class="card-body">
               <h4 class="card-title">Change Password</h4>
               <form class="form-sample" @submit="changePassword">
                   <div class="row">
                <div class="col-md-6">
                  <b-form-group horizontal label="Change Password">
                    <b-form-input type="text" v-model="password" required=""></b-form-input>
                  </b-form-group>
                </div>
                </div>
                 <hr>
                <b-button variant="primary" class="btn-fw" type="submit">Update Password</b-button>
                   </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
export default {
  name: 'news',
  props: ['id'],
  components: {
    VueEditor,
    Multiselect,
    vSelect
  },
  data () {
    return {
      username: '',
      name: '',
      phone: '',
      email: '',
      error: '',
      loading: false,
      phone: '',
      organization: '',
      is_rescuer: '',
      issnakeexpert: '',
      is_rescuer_Available: '',
      password: '',
    }
  },
    mounted: function () {
    this.getList()
  },
  methods: {
        getList () {
      this.loading = true
      axios({
       url: 'https://sarpatnapi.leopardtechlabs.in/user/get',
        method: 'GET',
        params: {
            id: this.id
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        },
      }).then(response => {
        this.username = response.data.data.username
        this.name = response.data.data.name
        this.email = response.data.data.email
        this.phone = response.data.data.phone
        this.organization = response.data.data.organization
        this.is_rescuer = response.data.data.is_rescuer
        this.issnakeexpert = response.data.data.issnakeexpert
        this.is_rescuer_Available = response.data.data.is_rescuer_Available
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    onSubmit (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/user/adminedit',
        data: {
          id: this.id,
          name: this.name,
          username: this.username,
          email: this.email,
          phone: this.phone,
          organization: this.organization,
          is_rescuer: this.is_rescuer,
          is_rescuer_Available: this.is_rescuer_Available,
          issnakeexpert: this.issnakeexpert,
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })
        .then(response => {
            this.getList();
          alert('Successfully Updated User Details')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.msg
          alert('Failed')
        })
    },
        changePassword (evt) {
      evt.preventDefault()
      this.loading = true
      axios({
        method: 'post',
        url: 'https://sarpatnapi.leopardtechlabs.in/user/editpassword',
        data: {
          id: this.id,
          password: this.password,
        },
        headers: {
          'x-auth-token': localStorage.getItem('token')
        }
      })
        .then(response => {
            this.getList();
          alert('Successfully Updated Password')
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.error = e.response.data.msg
          alert('Failed')
        })
    }
  }
}
</script>
<style scoped lang="scss">
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  width: 20%;
}
</style>


// WEBPACK FOOTER //
// src/views/forms/editusers.vue